import { Controller } from "@hotwired/stimulus"

// Opens an expense's Belegpositionen under its row in the Spesenzentrale
// (expenses/table/_items_toggle.html.erb).
//
// The first click inserts a full-width row holding a lazy Turbo frame (Expenses::ItemsController
// #index); later clicks only show or hide it, so edits made in the grid are not thrown away by
// closing it. The panel row is a sibling of the expense's row, not part of it: a turbo stream that
// replaces the expense's row (an item edit moving its amount) leaves the panel alone, and this
// controller, connecting on the new row, finds the panel again and shows the chevron open.
export default class extends Controller {
  static targets = ["icon"]
  static values = { url: String, frameId: String }

  connect() {
    this.render(this.panel && !this.panel.hidden)
  }

  toggle(event) {
    event.preventDefault()
    let panel = this.panel
    if (panel) {
      panel.hidden = !panel.hidden
    } else {
      panel = this.buildPanel()
      this.row.after(panel)
    }
    this.render(!panel.hidden)
  }

  get row() {
    return this.element.closest("tr")
  }

  get panel() {
    const next = this.row?.nextElementSibling
    return next?.dataset.expenseItemsPanel === this.frameIdValue ? next : null
  }

  buildPanel() {
    const panel = document.createElement("tr")
    // The id lets a stream that removes the expense's row remove its panel with it
    // (expenses/destroy.turbo_stream.erb).
    panel.id = `${this.frameIdValue}_panel`
    panel.dataset.expenseItemsPanel = this.frameIdValue
    const cell = document.createElement("td")
    cell.colSpan = this.row.cells.length
    cell.className = "border-b border-gray-200 bg-gray-50 py-3 pl-12 pr-4"
    const frame = document.createElement("turbo-frame")
    frame.id = this.frameIdValue
    frame.setAttribute("src", this.urlValue)
    cell.append(frame)
    panel.append(cell)
    return panel
  }

  render(open) {
    this.element.setAttribute("aria-expanded", open ? "true" : "false")
    if (this.hasIconTarget) this.iconTarget.classList.toggle("rotate-90", open)
  }
}
